module.exports = __webpack_public_path__ + "static/media/video.e73a8491.mp4";